<template>
  <!-- <v-toolbar-items> -->
  <v-system-bar style="position:fixed; width:100%;z-index:5; margin-bottom:10px;">
    <!-- <v-icon color="green darken-2">memory</v-icon> -->

    <v-icon color="blue darken-2">router</v-icon>
    <span v-if="get_socketConnectionStatus == true" style="color: green">&#9679;</span>
    <span v-else-if="get_socketConnectionStatus == false" style="color: red">&#9679;</span>

    <!-- <v-badge overlap color="red" style="align-items:center"> -->
    <!-- <template v-slot:badge>
        <span>!</span>
      </template>
      <v-icon color="grey" style="align-items:center">mail</v-icon>
    </v-badge>-->
    <!-- <v-icon color="purple darken-2">dialpad</v-icon> -->
    <!-- <v-badge left color="secondary">
      <span slot="badge">15000</span>
      <span slot="default">Test</span>
      <v-icon large color="grey lighten-1" style="align-items:center">&nbsp;</v-icon>
    </v-badge>-->
    <!-- <v-icon color="teal darken-2">email</v-icon> -->
    <!-- <v-badge color="green">
      <template v-slot:badge>
        <v-icon dark small>list</v-icon>
      </template>
      <span>Lists</span>
    </v-badge>-->
    <!-- <v-icon color="blue-grey darken-2">call_split</v-icon> -->
    <!-- <v-icon color="orange darken-2">present_to_all</v-icon> -->
    <span class="blue-grey--text text--darken-1">&nbsp;&nbsp;Last update:&nbsp;</span>
    <span
      class="yellow--text text--darken-2"
      style="font-family:monospace"
    >{{get_updatedTime | moment("MM-DD-YYYY h:mm:ss a")}}</span>
  </v-system-bar>
  <!-- </v-toolbar-items> -->
</template>

<script>
import DeviceStatusService from "@/services/DeviceStatusService";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      devData: {}
    };
  },
  mounted() {
    this.getDevStatus();
  },
  methods: {
    async getDevStatus() {
      const response = await DeviceStatusService.fetchDeviceStatus();
      this.devData = response.data.devData;
    }
  },
  computed: {
    ...mapGetters(["get_updatedTime", "get_socketConnectionStatus"])
  }
};
</script>